import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { BecareService } from 'src/app/services/becare.service';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-authenticate',
  templateUrl: './authenticate.component.html',
  styleUrls: ['./authenticate.component.scss']
})
export class AuthenticateComponent implements OnInit {

  loginForm: UntypedFormGroup;
  errormessage: string = null;

  constructor(private becare: BecareService, private dialogRef: MatDialogRef<AuthenticateComponent>,
              @Inject(MAT_DIALOG_DATA) data, private dialog: MatDialog) {
                this.loginForm = new UntypedFormGroup({
                  login: new UntypedFormControl(),
                  password: new UntypedFormControl()
                });
                this.dialogRef.beforeClosed().subscribe(event => {
                  console.log('before close ', event);
                });
              }

  ngOnInit(): void {
  }

  authenticate() {
    this.errormessage = null;
    this.becare.authenticate(this.loginForm.controls.login.value, this.loginForm.controls.password.value).subscribe(result => {
      if (!result) {
        console.log('FAILED .... retry');
        this.errormessage = 'Failed to authenticate, retry';
      } else {
        // Success ... close dialog
        this.errormessage = null;
        this.dialogRef.close(true);
      }
    }, error => {
      // Failed
      console.log('FAILED .... retry');
      this.errormessage = 'Failed to authenticate, retry';
    });
  }
}
